import React from 'react';
import { Subscription } from 'src/services/firebaseInit';

export const messages = {
  trial: {
    title: 'Your free 7-day trial has ended',
    body: () => (
      <>
        But it's not too late to take the next step. Please, purchase an annual
        subscription to keep using Appgami Retrospectives. If you need
        assistance or support, feel free to contact us at{' '}
        <a rel="noreferrer" target="_top" href="mailto:support@appgami.com">
          support@appgami.com
        </a>
        .
      </>
    ),
    button: 'Subscribe now',
  },
  paid: {
    title: 'Your subscription has expired',
    body: (subscription: Subscription) => (
      <>
        Your subscription renewal is overdue since{' '}
        {new Date(subscription.endsAt!).toLocaleDateString()}. Please ensure
        your payment method is up to date or manage your subscription via our
        customer portal. If you need assistance or support, feel free to contact
        us at{' '}
        <a rel="noreferrer" target="_top" href="mailto:support@appgami.com">
          support@appgami.com
        </a>
        .
      </>
    ),
    button: 'Go to customer portal',
  },
};
